import app from '../../firebase';
import { getFirestore, doc, updateDoc, } from 'firebase/firestore';
import { uploadBytes, ref, getStorage, getDownloadURL } from 'firebase/storage';
import defaultHero from '../../media/hero.png';
import { useRef } from 'react';
export default function Hero({ profile }) {
    const hero = useRef(null);

    const handleHeroClick = () => {
        hero.current.click();
    }

    const handleHeroChange = async e => {
        await uploadBytes(ref(getStorage(app), `heroes/${profile[0]}`), e.target.files[0])
            .then(() => {
                getDownloadURL(ref(getStorage(app), `heroes/${profile[0]}`))
                    .then(hero => updateDoc(doc(getFirestore(app), `users/${profile[0]}`), { hero }))
            }); window.location.reload();
    }

    return(
        <>
            <div className="bg-light">
                <img
                    src={profile && profile[1].hero ? profile[1].hero : defaultHero}
                    className="img-fluid w-100 hero mb-2"
                    style={{ height: 300 }}
                    alt=""
                />

                <button
                    className="btn btn-sm btn-secondary mx-2"
                    onClick={handleHeroClick}>
                        Change Cover Photo
                </button>

                <input
                    type="file"
                    accept="image/png, image/jpeg"
                    ref={hero}
                    onChange={handleHeroChange}
                    style={{ display: 'none' }}
                />
            </div>
        </>
        
    )
}